module.exports = __webpack_public_path__ + "img/Photo_4___People_and_Pleasures_Boat_excursion_2009_20_81.4a8e3444.jpg";